jQuery( document ).ready(function() {

    if($('.listgrandspersonnages_cards').length > 0) {
  
          $('.listgrandspersonnages_showmore').click(function(e) {
              e.preventDefault();
              var id_cat = $(this).data('id');
              var click = $(this).data('click');
              if (click == 0) {
                for (var i=6; i<11; i++) {
                    $('#cards'+id_cat+ ' .item_'+i).addClass('show');
                }
              } else if (click == 1) {
                for (var i=11; i<16; i++) {
                    $('#cards'+id_cat+ ' .item_'+i).addClass('show');
                }
              } else if (click == 2) {
                for (var i=16; i<21; i++) {
                    $('#cards'+id_cat+ ' .item_'+i).addClass('show');
                }
              } else if (click == 3) {
                for (var i=21; i<27; i++) {
                    $('#cards'+id_cat+ ' .item_'+i).addClass('show');
                }
              } else {
                $(this).hide();
              }

              $(this).data("click", click + 1);
                
          });
  
    }
  
  });